import { forwardRef } from 'react';
import styles from './Input.module.scss';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    placeholder: string;
    type: string;
    id: string;
    autoComplete?: string;
}

function InputBase({ label, placeholder, type, id, ...props }: InputProps, ref: React.Ref<HTMLInputElement>) {
    const randomName = `input-${Math.random().toString(36).substring(2, 15)}`;
    
    return  <div className={styles.formGroup}>
                <input 
                    ref={ref}
                    type={type} 
                    id={id} 
                    name={randomName}
                    placeholder={placeholder} 
                    autoComplete="new-password"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    autoSave="off"
                    {...props}
                />
                <label htmlFor={id}>{label}</label>
            </div>
}

export const Input = forwardRef(InputBase);
